import { LEAD_NAME_MAX_LENGTH } from '@constants/generic';
import {
  getLeadNameValidationError,
  isInvalidLeadName
} from '@utils/validations';

export const isMoveToCofeeNameInvalid = (name: string): boolean =>
  isInvalidLeadName(name, LEAD_NAME_MAX_LENGTH);

export const getMoveToCofeeNameError = (name: string): string =>
  getLeadNameValidationError(name, LEAD_NAME_MAX_LENGTH);
